<template>
  <div class="row mt-5 justify-content-between">
    <div class="col-sm-3" v-if="checkForPermission(add_sales_profile_turnover_permission)">
      <h4 class="card-title mb-3">Enter last visit</h4>
      <form @submit.prevent="addSalesTurnover">
        <div class="row">
          <div class="col-12 mt-3">
            <label>Visit Date</label>
            <date-picker v-model="filter.visitDate" format="YYYY-MM-DD" valueType="format"
                         :class="{'is-invalid': v$.filter.visitDate.$error}">
            </date-picker>
            <p
                v-for="error of v$.filter.visitDate.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-12 mt-3">
            <label>Product</label>
            <multiselect v-model="filter.productCode" :options="products.objects" placeholder="Select one" label="productName" track-by="productName"
                         :class="{'is-invalid': v$.filter.visitDate.$error}" :searchable="true" :loading="isLoading" :internal-search="false" @search-change="asyncFindProduct">
              <span slot="noResult">No product found. Change search query.</span>
            </multiselect>
            <p
                v-for="error of v$.filter.productCode.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-12 mt-3">
            <label>Current Stock</label>
            <input
                v-model="filter.currentStock"
                name="name"
                type="number"
                class="form-control"
                :class="{
            'is-invalid': v$.filter.visitDate.$error,
          }"
            />
            <p
                v-for="error of v$.filter.currentStock.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-12 mt-3">
            <b-form-checkbox
                value="true"
                unchecked-value="false"
                class="form-check-right"
                v-model="filter.demo"
                plain
            >Demo</b-form-checkbox>
          </div>
          <div v-for="(error, index) in customerErrors" :key="index" style="color: #D13704;">
            {{error.message}}
          </div>
          <div class="mt-3 col-12">
            <b-button variant="info" size="lg" class="py-2 text-white w-100" disabled v-if="customerLoading">
              <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
              Loading
            </b-button>
            <b-button variant="info" size="lg" class="py-2 text-white w-100 text-white" type="submit" v-else>
              Enter Visit
            </b-button>
          </div>
        </div>
      </form>
    </div>
    <div class="col-sm-8">
      <data-table :columns="columns" :rows="turnover.objects" :has-pagination="false" @onSearch="updateTurnoverPage"/>
      <b-pagination
          v-model="turnoverCurrentPage"
          :total-rows="turnover.total"
          :per-page="perPage"
          size="lg"
          align="center"
          class="mt-3"
      />
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import DataTable from "@/components/data-table";
import {required} from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import {mapActions, mapGetters} from "vuex";
import {ALL_PRODUCTS_SIMPLE} from "@/gql/stock";
import {successToast} from "@/components/successToast";
import {permissions} from "@/router/permissions";
export default {
  name: "turn-over",
  components: {
    DataTable,
    Multiselect
  },
  setup () {
    return { v$: useVuelidate() }
  },
  data(){
    return{
      filter:{
        visitDate: "",
        currentStock: "",
        productCode: "",
        demo: ""
      },
      add_sales_profile_turnover_permission: permissions.add_sales_profile_turnover_permission,
      productSearchKeyword: "",
      isLoading: false,
      turnoverCurrentPage: 1,
      perPage: 30,
      columns:[
        {
          field: 'turnoverProductName',
          label: 'Product Name'
        },
        {
          field: 'currentStock',
          label: 'Stock Amount'
        },
        {
          field: 'lastUpdatedBy',
          label: 'Added By'
        },
        {
          field: 'visitDate',
          label: 'Visit Date'
        },
        {
          field: 'weekVisited',
          label: 'Week Visited'
        },
        {
          field: 'demo',
          label: 'Demo'
        }
      ],
      products: {
        objects: []
      }
    }
  },
  props: {
    turnover : {
      type: Object,
    }
  },
  watch: {
    turnoverCurrentPage(){
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      this.updateTurnoverPage()
    }
  },
  validations () {
    return {
      filter:{
        visitDate: {required},
        currentStock: {required},
        productCode: {required},
      }
    }
  },
  computed: {
    ... mapGetters({
      customerLoading: 'customers/customerLoading',
      customerErrors: 'customers/customerErrors'
    }),
  },
  apollo: {
    products: {
      query: ALL_PRODUCTS_SIMPLE,
      variables(){
        return{
          page: 1,
          perPage: 30,
          searchKeyword: this.productSearchKeyword
        }
      }
    }
  },
  methods: {
    ... mapActions({
      salesTurnover: 'customers/addNewSalesProfileTurnover',
    }),
    async addSalesTurnover() {
      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }

      let new_demo = 0
      if (this.filter.demo === "true"){
        new_demo = 1
      }

      const data = {
        feedbackId: this.$route.params.id,
        visitDate: this.filter.visitDate,
        productCode: this.filter.productCode.publicId,
        currentStock: parseInt(this.filter.currentStock),
        demo: new_demo
      }
      await this.salesTurnover(data).then(resp => {
        this.$emit('updateProfile')
        if(resp.publicId){
          successToast(`New Sales Turnover added successfully`)
        }
      })

      this.v$.$touch();
    },
    updateTurnoverPage(data){
      this.$emit('changeTurnoverPage', this.turnoverCurrentPage, data)
    },
    asyncFindProduct (query) {
      this.isLoading = true
      this.productSearchKeyword = query
      this.isLoading = false
    }
  }
}
</script>

<style scoped>

</style>
